import { FormFragment } from '../../generated/graphql';
import React, { FC } from 'react';
import Form from '../Form';
import { Box } from '@rebass/grid';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

interface Props {
    forms: FormFragment[];
}

const FormBlock: FC<React.PropsWithChildren<Props>> = ({ forms }) => (
    <>
        {forms.map((form, i) => {
            const hasRecaptchaEnabled = form.settings?.integrations?.some(
                integration => integration?.handle === 'recaptcha' && integration?.enabled === true
            );
            if (hasRecaptchaEnabled) {
                return (
                    <GoogleReCaptchaProvider key={form.id ?? i} reCaptchaKey="6LdwiogUAAAAAPD40Lc0AopJ2sYPER9WVGBW0_RY">
                        <Box mb={[3, 5]} mt={[4, 6]}>
                            <Form form={form} />
                        </Box>
                    </GoogleReCaptchaProvider>
                );
            }
            return (
                <Box key={form.id ?? i} mb={[3, 5]} mt={[4, 6]}>
                    <Form form={form} />
                </Box>
            );
        })}
    </>
);

export default FormBlock;
